var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGraboxy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 37,
    viewBox: "0 0 163 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5443 8.8051C14.2538 7.6731 12.385 7.03457 10.7981 7.03457C6.98596 7.03457 4.46434 9.22596 4.46434 13.5363C4.46434 16.3663 6.05126 19.8929 10.7981 19.8929C12.2365 19.8929 13.527 19.6752 15.1139 18.4852V15.3069H10.2938V11.6351H19V20.3283C17.2797 22.7955 14.4762 24 10.7235 24C2.95137 24 0 18.7028 0 13.5363C0 7.94884 3.38175 3 10.7829 3C13.5125 3 16.0335 3.71113 18.3326 6.03318L15.5443 8.8051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 23H36.9612L31.7735 16.455H28.5334V23H24V3C27.3149 3 30.3466 3 33.5874 3C38.4926 3 41.0785 6.19943 41.0785 9.76406C41.0785 12.3937 40.2906 14.6728 36.3963 16.0314L41.9405 22.6494V23H42ZM28.5188 6.8422V12.6713H33.7058C35.8022 12.6713 36.6642 11.1081 36.6642 9.89553C36.6642 8.53691 35.7275 6.8422 33.6318 6.8422H28.5188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6518 19.5815H51.274L49.8322 23H45L54.0101 3H58.9158L68 23H63.1684L61.6518 19.5815ZM56.4629 7.55805L52.9243 15.6662H59.9123L56.4629 7.55805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.099 3.01463C85.0022 3.01463 88.3127 4.7239 88.3127 8.42006C88.3127 10.0563 87.5685 11.6194 85.5943 12.4814C88.2519 13.4018 89.3454 15.973 88.9054 18.3105C88.3127 21.5099 85.5186 23 81.3876 23C78.0771 23 74.3868 23 71 23V3H81.099V3.01463ZM75.4345 10.7721H81.0388C82.8759 10.7721 83.7572 10.0563 83.7572 8.85829C83.7572 7.71878 82.8759 6.79844 81.099 6.79844H75.4345V10.7721ZM75.4345 19.1724H81.099C83.1645 19.1724 84.1215 18.3251 84.1215 16.8934C84.1215 15.4763 83.0888 14.5413 81.0233 14.5413C79.1856 14.5413 77.2722 14.5413 75.4196 14.5413V19.1724H75.4345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 27C98.0719 27 92 20.925 92 13.5C92 6.0603 98.0719 0 105.5 0C112.928 0 119 6.07499 119 13.5C119 20.925 112.928 27 105.5 27ZM105.5 3.84459C100.209 3.84459 95.8464 8.12934 95.8464 13.4853C95.8464 18.8413 100.135 23.1261 105.5 23.1261C110.791 23.1261 115.154 18.8413 115.154 13.4853C115.139 8.12934 110.776 3.84459 105.5 3.84459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.098 3H139.928V3.21911L133.282 12.9635L140 22.8539V23H135.113L130.5 15.9584L125.887 23H121V22.8539L127.703 12.9635L121.13 3.21911V3H125.959L130.572 10.1146L135.098 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.905 10.9766L157.916 3.01457H163V3.23374L155.018 15.038V23H150.633V15.0964L143 3.21911V3H148.084L152.905 10.9766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.254 10.203C110.817 10.8646 110.154 11.3007 109.28 11.3007C107.894 11.3007 106.719 10.1278 106.719 8.74439C106.719 8.15793 107.005 7.72185 107.307 7.2857C106.87 7.21054 106.508 7 105.996 7C102.712 7 100 9.70677 100 13C100 16.2932 102.697 19 105.996 19C109.28 19 111.992 16.2932 111.992 13C112.052 11.9624 111.766 11.015 111.254 10.203Z",
    fill: "#EB3865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 34.6116L92.5011 37L101 24.3883L97.4989 22L89 34.6116Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 37,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraboxy);
export default __webpack_public_path__ + "static/media/graboxy.c40bc63ddc00ac38ac651e8e8ca3a593.svg";
export { ForwardRef as ReactComponent };